// Static content: images, motorcycles, contact info

export const LOGO_URL = "/jhossy-logo.png";

// Hero slider — curated high-quality motorcycle & shop photos
export const HERO_IMAGES = [
  {
    src: "https://customer-assets.emergentagent.com/job_moto-navi-hub/artifacts/k0lluth7_77db497d-ba3a-4de2-8570-b1cd9d0b41d6.JPG",
    alt: "Honda Navi in front of the San Juan del Sur sign",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_moto-navi-hub/artifacts/ejzdix26_8ef3fc78-a25e-4273-8f1a-64259afed568.JPG",
    alt: "Jhossy fleet with RENT ME signs",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_14b8df9a-5be1-4ee2-868e-833d713ddc1a/artifacts/mj4er2ht_d59b2a1c-2749-4f6c-ac17-0fd0b3fbcfee.JPG",
    alt: "Genesis SX1 150cc dual-sport close-up",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_moto-navi-hub/artifacts/mor16sc3_WhatsApp%20Image%202026-07-06%20at%2013.27.28%20%282%29.jpeg",
    alt: "Motos parked at the Jhossy shop",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_moto-navi-hub/artifacts/7myw088u_WhatsApp%20Image%202026-07-06%20at%2013.27.28%20%281%29.jpeg",
    alt: "Rental motos lined up ready to ride",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_moto-navi-hub/artifacts/h4lfc7ky_WhatsApp%20Image%202026-07-06%20at%2013.27.28%20%285%29.jpeg",
    alt: "Riders exploring San Juan del Sur",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_moto-navi-hub/artifacts/c88xwt95_WhatsApp%20Image%202026-07-06%20at%2013.27.28%20%283%29.jpeg",
    alt: "Rider with the Jhossy fleet",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_14b8df9a-5be1-4ee2-868e-833d713ddc1a/artifacts/rn6dkd9c_8ef3fc78-a25e-4273-8f1a-64259afed568.JPG",
    alt: "Couple picking up their motorcycle",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_moto-navi-hub/artifacts/mdwx5w18_WhatsApp%20Image%202026-07-06%20at%2013.27.28%20%284%29.jpeg",
    alt: "Rider giving thumbs up on a Navi",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_moto-navi-hub/artifacts/5721jpnf_WhatsApp%20Image%202026-07-06%20at%2013.27.27.jpeg",
    alt: "Customer posing with rental motos",
  },
];

// Gallery — every photo the user provided
export const GALLERY_IMAGES = [
  {
    src: "https://customer-assets.emergentagent.com/job_moto-navi-hub/artifacts/jkv5t4tn_WhatsApp%20Image%202026-07-06%20at%2013.27.28.jpeg",
    alt: "Honda Navi in front of San Juan del Sur sign",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_moto-navi-hub/artifacts/0ckj0ibx_WhatsApp%20Image%202026-07-06%20at%2013.27.29%20%281%29.jpeg",
    alt: "Full fleet at Jhossy",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_moto-navi-hub/artifacts/mor16sc3_WhatsApp%20Image%202026-07-06%20at%2013.27.28%20%282%29.jpeg",
    alt: "Motos at the shop",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_moto-navi-hub/artifacts/44gjt106_WhatsApp%20Image%202026-07-06%20at%2013.27.29.jpeg",
    alt: "Genesis SX1 150cc close-up",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_moto-navi-hub/artifacts/7myw088u_WhatsApp%20Image%202026-07-06%20at%2013.27.28%20%281%29.jpeg",
    alt: "Rental motos lined up",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_14b8df9a-5be1-4ee2-868e-833d713ddc1a/artifacts/g8fqaros_77db497d-ba3a-4de2-8570-b1cd9d0b41d6.JPG",
    alt: "Happy customer with Genesis SX1",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_14b8df9a-5be1-4ee2-868e-833d713ddc1a/artifacts/mj4er2ht_d59b2a1c-2749-4f6c-ac17-0fd0b3fbcfee.JPG",
    alt: "Riders with helmets — B&W",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_14b8df9a-5be1-4ee2-868e-833d713ddc1a/artifacts/cu5jfm7h_20f2145b-15f2-4425-aa32-1e587219b06d.JPG",
    alt: "Customer picking his Navi",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_14b8df9a-5be1-4ee2-868e-833d713ddc1a/artifacts/rn6dkd9c_8ef3fc78-a25e-4273-8f1a-64259afed568.JPG",
    alt: "Couple picking up their moto",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_moto-navi-hub/artifacts/d0sflm9d_WhatsApp%20Image%202026-07-06%20at%2013.27.28%20%286%29.jpeg",
    alt: "Customer with 3 Navis",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_moto-navi-hub/artifacts/h4lfc7ky_WhatsApp%20Image%202026-07-06%20at%2013.27.28%20%285%29.jpeg",
    alt: "Two riders on their Navis",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_moto-navi-hub/artifacts/mdwx5w18_WhatsApp%20Image%202026-07-06%20at%2013.27.28%20%284%29.jpeg",
    alt: "Rider giving thumbs up",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_moto-navi-hub/artifacts/c88xwt95_WhatsApp%20Image%202026-07-06%20at%2013.27.28%20%283%29.jpeg",
    alt: "Customer with fleet",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_moto-navi-hub/artifacts/5721jpnf_WhatsApp%20Image%202026-07-06%20at%2013.27.27.jpeg",
    alt: "Rider posing with fleet",
  },
];

export const PACKAGES = [
  {
    id: "duo",
    bikes: 2,
    days: 4,
    price: 140,
    badge: "packages.duo.badge",
    perfectFor: "packages.duo.for",
    highlight: false,
  },
  {
    id: "trio",
    bikes: 3,
    days: 4,
    price: 210,
    badge: "packages.trio.badge",
    perfectFor: "packages.trio.for",
    highlight: true,
  },
  {
    id: "quad",
    bikes: 4,
    days: 3,
    price: 220,
    badge: "packages.quad.badge",
    perfectFor: "packages.quad.for",
    highlight: false,
  },
];

export const MOTORCYCLES = [
  {
    id: "navi",
    nameKey: "moto.navi.name",
    engineKey: "moto.navi.engine",
    descKey: "moto.navi.desc",
    image:
      "https://customer-assets.emergentagent.com/job_moto-navi-hub/artifacts/qpyq7e6t_image.webp",
    productShot: true,
    prices: { day: 20, week: 105, month: 300 },
    specs: ["110cc", "Automático", "Honda"],
    accent: "#111111",
  },
  {
    id: "sx",
    nameKey: "moto.sx2.name",
    engineKey: "moto.sx2.engine",
    descKey: "moto.sx2.desc",
    image: "/genesis-sx-product.png",
    productShot: true,
    imageScale: 1.35,
    prices: { day: 20, week: 110, month: 320 },
    specs: ["150cc", "Manual", "Dual-Sport"],
    accent: "#fb923c",
  },
];

// WhatsApp
export const WHATSAPP_NUMBER = "50588564290";
export const WHATSAPP_DISPLAY = "+505 8856-4290";
export const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}`;
export const buildWhatsappLink = (msg) =>
  `${WHATSAPP_LINK}?text=${encodeURIComponent(msg)}`;

export const LOCATION = {
  city: "San Juan del Sur",
  country: "Nicaragua",
  address:
    "La Mar del Sur Tours, Hospedaje Don Wilfredo BAC, 25 mtrs al Este, San Juan del Sur",
  email: "jhossylopez@hotmail.com",
  coords: "11.254429,-85.871905",
  mapEmbed:
    "https://www.google.com/maps?q=11.254429,-85.871905&z=17&output=embed",
  mapLink: "https://maps.app.goo.gl/jtSiCWrrcbGxhGo36",
  directionsLink:
    "https://www.google.com/maps/dir/?api=1&destination=11.254429,-85.871905",
};
